<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre5" id="calibre_pb_0">August Ludolf Friedrich Schauman</h2>
<h1 class="calibre6">ON THE ROAD<br class="calibre3"/>WITH<br class="calibre3"/>WELLINGTON</h1>
<h2 class="calibre7">The Diary of a War Commissary</h2>
<p class="paranoindent"> </p>
<h3 class="calibre8">New Introduction by Bernard Cornwel</h3>
<p class="paranoindent"> </p>
<div class="image-wrap">
<div class="image">
<img alt="image" class="calibre1" src="images/00003.jpeg"/>
</div>
</div>
<p class="paranoindent"> </p>
<p class="paranoindent"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?eeb882a6